// extracted by mini-css-extract-plugin
module.exports = {"pintxo-field-container":"Field_pintxo-field-container__oa0Zr","pintxo-field-container__footer":"Field_pintxo-field-container__footer__OIWWk"};